import backendRedirect from '../../backendRedirect'

const SOUNDPLAY_SERVER = backendRedirect.apiTrafficManager + '/tipsoundplay'
const TIP_SERVER = backendRedirect.apiTrafficManager + '/tipsemantic'
const SERVER_ROOT = '/api'
const SERVER = backendRedirect.apiTrafficManager + SERVER_ROOT

export const StoreConfig = {
  SERVER_ROOT: SERVER_ROOT,
  SERVER: SERVER,
  SOUNDPLAY_SERVER: SOUNDPLAY_SERVER,
  TIP_SERVER: TIP_SERVER
}
